import React, { useState, useContext } from 'react';
import {Form, Input, Select, Button, Row, Space } from 'antd';
import { validatePhoneNumber, maskPhoneNumber, isValidPhoneNumber } from '../../../../Validation';
import { updateUser } from '../../../../services/UserService';
import { NocContext } from '../../../../context/noc-context';
import { PermissionsContext } from '../../../../router/DashboardRoutes';
import { FormField } from '../../../UI/FormField/FormField.component';
import { useMessage } from '../../../UI/MessageProvider';

const { Option } = Select;

export const EditCustomerInformationForm = ({dataSource, setVisible, refreshHandler, ...props}) => {

    const userPermissions = useContext(PermissionsContext);
    const allowEdit = userPermissions.noc.editCustomer;

    const [form] = Form.useForm();
    const message = useMessage();

    const [formValuesChanged, setFormValuesChanged] = useState(false);
    const [nocState, dispatchNoc] = useContext(NocContext);
    const { username, email, companyName, firstName, lastName, phone } = dataSource;

    const onCancel = () => {
        setFormValuesChanged(false);
        form.resetFields();
    }

    const onFinish = (data) => {
        Object.assign(data, {id: dataSource.id, username: data.username})
        updateUser({...data, userID: dataSource.id, nocUpdate: true}).then(function(response){
            if (response.message) {
                dispatchNoc({
                    type: 'UPDATE_CUSTOMER_INFORMATION', 
                    payload: data,
                })
                refreshHandler();
                setFormValuesChanged(false);
                setVisible(false);
                setTimeout(() => { 
                    message.success(<span><strong>{data.companyName}</strong> has been successfully updated.</span>, 2.5)
                }, 2000)
                return
            } 

            message.error((response.message) ? response.message : response.error, 4);
            setVisible(false);
        });
    }

    return(
        <>
            <Form 
                form={form}
                autoComplete='off'
                name='edit-customer-information-form'
                layout="vertical"
                initialValues={dataSource}
                onValuesChange={(changedValues) => changedValues ? setFormValuesChanged(true) : setFormValuesChanged(false)}
                onFinish={(values) => onFinish(values)} 
                >

                <FormField editable={allowEdit} text={username} label="Username" name="username" tooltip="This field can't be edited after saving">
                    <Input disabled={true}/>
                </FormField>
                <FormField editable={allowEdit} text={email} label="Email address" name="email" rules={[{ required: true }]}>
                    <Input/>
                </FormField>
                <FormField editable={allowEdit} text={companyName} label="Company" name="companyName" rules={[{ required: true }]}>
                    <Input />
                </FormField>
                <FormField editable={allowEdit} text={firstName} label="Name" name="firstName">
                    <Input/>
                </FormField>
                <FormField editable={allowEdit} text={lastName} label="Last name" name="lastName">
                    <Input/>
                </FormField>
                <FormField 
                    editable={allowEdit}
                    text={phone} 
                    hasFeedback
                    label="Phone number" 
                    name="phone" 
                    rules={[
                        {
                            type: "tel", 
                            validator: (rule, value) => {
                                if(!rule.required && !value){
                                    return Promise.resolve();
                                }

                                if(validatePhoneNumber(value) && isValidPhoneNumber(value)){
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Please enter valid phone number'));
                            }
                        }, 
                        ]}
                    >
                    <Input onInput={(e) => maskPhoneNumber(e) }/>
                </FormField>

                {/* <Form.Item label="Access Type" name="access" rules={[{ required: true }]}>
                    <Select disabled={formDisabled}>
                        <Option value='W'>Read/Write</Option>
                        <Option value='R'>Read</Option>
                    </Select>
                </Form.Item> */}

                { allowEdit &&
                    <Form.Item>
                        <Row justify="end" style={{gap: 10}}>
                            {formValuesChanged ? 
                                <Space>
                                    <Button onClick={onCancel}>Cancel</Button>  
                                    <Button type='primary' htmlType='submit' disabled={!formValuesChanged}>Save changes</Button>
                                </Space>
                            : 
                                <Space>
                                    <Button onClick={() => setVisible(false)}>Close</Button>
                                    <Button type='primary' htmlType='submit' disabled={!formValuesChanged}>Save changes</Button>
                                </Space>
                            }
                        </Row>
                    </Form.Item>
                }
            </Form>
            { !allowEdit && <Button onClick={() => setVisible(false)}>Close</Button>}
        </>
    );
};

EditCustomerInformationForm.defaultProps = {
    dataSource: '', 
}